'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var classNames = require('classnames/bind');
var Tab = require('./TabComponents/Tab.js');
var TabPanel = require('./TabComponents/TabPanel.js');
var Tabs_module = require('./Tabs.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var cx = classNames__default["default"].bind(Tabs_module["default"]);
var TabsContext = React.createContext(undefined);
var Tabs = function (_a) {
    var _b = _a.justifyTitles, justifyTitles = _b === void 0 ? 'start' : _b, _c = _a.tabItems, tabItems = _c === void 0 ? [] : _c, _d = _a.panels, panels = _d === void 0 ? [] : _d, className = _a.className, tabPanelClass = _a.tabPanelClass;
    var _e = React.useState(tabItems[0].label), activeTab = _e[0], setActiveTab = _e[1];
    var _f = React.useState([]), refs = _f[0], setRefs = _f[1];
    if (tabItems.length !== panels.length) {
        throw new Error('The properties "tabs" and "panels" must be equal in length');
    }
    var memoizedContextValue = React.useMemo(function () { return ({
        activeTab: activeTab,
        setActiveTab: setActiveTab,
    }); }, [activeTab, setActiveTab]);
    var setRefByIndex = function (ref, index) {
        refs[index] = ref;
        setRefs(refs);
    };
    var selectTab = function (tabItem) {
        var index = tabItems.indexOf(tabItem);
        refs[index].current.focus();
        setActiveTab(tabItem.label);
    };
    var previousTab = function (tabItem) {
        var index = tabItems.indexOf(tabItem);
        if (index > 0) {
            selectTab(tabItems[index - 1]);
        }
        else {
            selectTab(tabItems[tabItems.length - 1]);
        }
    };
    var nextTab = function (tabItem) {
        var index = tabItems.indexOf(tabItem);
        if (index < tabItems.length - 1) {
            selectTab(tabItems[index + 1]);
        }
        else {
            selectTab(tabItems[0]);
        }
    };
    var handleKeyUp = function (event, tabItem) {
        event.preventDefault();
        if (event.code === 'Enter') {
            selectTab(tabItem);
        }
        else if (event.code === 'ArrowLeft') {
            previousTab(tabItem);
        }
        else if (event.code === 'ArrowRight') {
            nextTab(tabItem);
        }
    };
    return (jsxRuntime.jsx(TabsContext.Provider, _tslib.__assign({ value: memoizedContextValue }, { children: jsxRuntime.jsxs("div", _tslib.__assign({ className: cx('tabs', "justify-titles-".concat(justifyTitles), className) }, { children: [jsxRuntime.jsx("div", _tslib.__assign({ className: Tabs_module["default"].tabTitles, role: "tablist" }, { children: tabItems.map(function (tabItem, index) { return (jsxRuntime.jsx(Tab.Tab, { tabItem: tabItem, index: index, setRefByIndex: setRefByIndex, onKeyup: handleKeyUp }, index)); }) })), jsxRuntime.jsx("div", _tslib.__assign({ className: Tabs_module["default"].panels }, { children: panels.map(function (_a, index) {
                        var label = _a.label, children = _a.children, panelDisplayTitle = _a.panelDisplayTitle;
                        return (jsxRuntime.jsxs(TabPanel.TabPanel, _tslib.__assign({ label: label, tabPanelClass: tabPanelClass }, { children: [panelDisplayTitle && (jsxRuntime.jsx("div", _tslib.__assign({ className: Tabs_module["default"].panelDisplayTitle }, { children: panelDisplayTitle }))), children] }), index));
                    }) }))] })) })));
};

exports.TabsContext = TabsContext;
exports["default"] = Tabs;
//# sourceMappingURL=Tabs.js.map
